import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css'; // reuse this if it contains shared styling

const milletData = {
  foxtail: {
    name: 'Foxtail Millet',
    image: '/images/millets/foxtail.webp',
    description:
      'Foxtail Millet, known as Thinai (தினை) in Tamil, is an ancient grain cultivated in dry regions of Dharmapuri, Krishnagiri, and Tiruvannamalai. Once a staple in traditional Tamil diets, it is now celebrated for its high fiber, low glycemic index, and nutrient density. Tamil people use thinai in dishes like pongal, upma, dosa, and payasam. It is believed to promote weight loss, support heart health, and manage blood sugar levels, making it ideal for diabetics and health-conscious individuals. Thinai is a wholesome grain deeply rooted in Tamil Nadu’s agricultural heritage and temple offerings.',
  },
  barnyard: {
    name: 'Barnyard Millet',
    image: '/images/millets/barnyard.webp',
    description:
      'Barnyard Millet, known as Kuthiraivali (குதிரைவாலி) in Tamil, is a traditional grain cultivated in hill and dry regions of Tamil Nadu such as Dindigul, Nilgiris, and Salem. It is prized for being light, gluten-free, and rich in iron and fiber. Tamil households prepare kuthiraivali in dishes like upma, pongal, dosa, and payasam. It is believed to cool the body, regulate blood sugar, and aid digestion. Often recommended during fasting and detox diets, barnyard millet is valued for its ability to provide quick energy without heaviness, making it a smart alternative to rice.',
  },
  browntop: {
    name: 'Browntop Millet',
    image: '/images/millets/browntop.webp',
    description:
      'Browntop Millet, known as Cholam Kuthirai (சோளம் குதிரை) or locally referred to as Mani Kuthiraivali, is a rare, ancient grain now being revived in Tamil Nadu’s dry zones like Theni, Dindigul, and Dharmapuri. It is known for its high dietary fiber, low glycemic index, and ability to grow without chemical inputs. In Tamil kitchens, browntop millet is used in upma, pongal, dosa, and even kanji. It is believed to help detoxify the body, improve gut health, and support diabetic-friendly diets. With its ability to keep the body light yet energetic, browntop millet is a true heritage grain making a healthy comeback.',
  },
  ragi: {
    name: 'Ragi Millet',
    image: '/images/millets/ragi.webp',
    description:
      'Ragi Millet, known as Kezhvaragu (கேழ்வரகு) in Tamil, is a time-honored grain grown widely in Dharmapuri, Krishnagiri, and Salem. Rich in calcium, iron, and dietary fiber, it has been a staple in Tamil village diets for generations. Tamil households use ragi to prepare kali, koozh, dosa, puttu, and kanji. It is believed to strengthen bones, aid digestion, and cool the body, especially during summer. Often given to children, pregnant women, and the elderly, kezhvaragu is considered a complete and wholesome grain deeply rooted in Tamil Nadu’s food traditions.',
  },
  little: {
    name: 'Little Millet',
    image: '/images/millets/little.webp',
    description:
      'Little Millet, known as Samai (சமை) in Tamil, is a traditional small grain cultivated in dry regions like Salem, Dindigul, and Krishnagiri. Rich in fiber, iron, and B-complex vitamins, it has long been part of rural Tamil Nadu’s wholesome diet. Tamil families use samai to prepare rice substitutes, pongal, upma, dosa, and even sweets like payasam. It is believed to help regulate blood sugar, improve digestion, and support weight management. Easy to cook and light on the stomach, samai is a smart, diabetic-friendly alternative to polished rice in daily meals.',
  },
  kodo: {
    name: 'Kodo Millet',
    image: '/images/millets/Kodo.webp',
    description:
      'Kodo Millet, known as Varagu (வரகு) in Tamil, is a resilient ancient grain cultivated in dry regions like Salem, Dharmapuri, and Madurai. It is rich in dietary fiber, antioxidants, and minerals like iron and calcium. In Tamil kitchens, varagu is used in place of rice to make pongal, upma, biryani, and even idli and dosa. It is believed to regulate cholesterol, aid digestion, and help manage diabetes and obesity. Valued for its ability to keep the body light and energetic, Kodo millet is a key part of Tamil Nadu’s millet revival movement.',
  },
  sorgham: {
    name: 'Sorghum Millet',
    image: '/images/millets/sorgham.webp',
    description:
      'Sorghum Millet, known as Cholam (சோளம்) in Tamil, is one of the oldest and most widely grown millets in Tamil Nadu, especially in Salem, Namakkal, and Tirunelveli regions. This drought-resistant grain is rich in iron, fiber, and protein, making it a staple in Tamil rural diets. Tamil people use cholam to prepare rotis, dosai, koozh, and puttu. It is believed to cool the body, support digestion, and boost energy without raising blood sugar levels. Valued for its satiating and nutritious qualities, sorghum millet continues to be a symbol of sustainable, traditional Tamil food wisdom.',
  },
  pearl: {
    name: 'Pearl Millet',
    image: '/images/millets/pearl.webp',
    description:
      'Pearl Millet, known as Kambu (கம்பு) in Tamil, is a hardy, traditional grain widely cultivated in hot and dry regions of Tamil Nadu like Ramanathapuram, Sivagangai, and Virudhunagar. Packed with calcium, iron, fiber, and slow-digesting carbs, it has been a village staple for centuries. Tamil people prepare kambu koozh, dosa, rotti, and kanji, especially during summer. Kambu is believed to cool the body, aid digestion, and strengthen bones. It’s a highly valued grain in Siddha diets and is cherished for keeping the body light, energized, and naturally nourished.',
  }
};



const MilletDetail = () => {
  const { type } = useParams();
  const millet = milletData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/millets');
    };
  

  if (!millet) return <h2>Millet product not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${millet.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Millets Products</button>
          <h2>{millet.name}</h2>
          <p>{millet.description}</p>
        </div>
        <div className="button-box">
          <button className="enquire-btn">ENQUIRE NOW</button>
        </div>
      </div>
    </section>
  );
};

export default MilletDetail;
